import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const fb = initializeApp({
	apiKey: process.env.REACT_APP_DB_API_KEY,
	authDomain: process.env.REACT_APP_DB_AUTH_DOMAIN,
	projectId: process.env.REACT_APP_DB_PROJECT_ID,
	storageBucket: process.env.REACT_APP_DB_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_DB_MESSAGING_SENDER_ID,
	appId: process.env.REACT_APP_DB_APP_ID,
});
const db = getFirestore();
const storage = getStorage();
export { db, storage };
export default fb;
